import {AfterViewInit, Component, ElementRef, Input, OnInit} from '@angular/core';
import {LogisticRoutesService} from '../../../../../../data/logistic-routes.service';
import {ProjectActivity} from '../../../../../../../project-misc/data/project/activity/project-activity';
import {
  ProjectWindowComponent
} from '../../../../../../../../../../../desktop/src/app/modules/project/view/project-window/project-window.component';
import {MatDialog} from '@angular/material/dialog';
import {ProjectActivityService} from '../../../../../../../project-misc/data/project/activity/project-activity.service';

@Component({
  selector: 'app-suggestion-activity',
  templateUrl: './suggestion-activity.component.html',
  styleUrls: ['./suggestion-activity.component.scss']
})
export class SuggestionActivityComponent implements OnInit, AfterViewInit {

  @Input()
  activity: ProjectActivity;

  @Input()
  dndActive: boolean;

  constructor(
    protected dialog: MatDialog,
    protected el: ElementRef,
    protected logisticRoutesService: LogisticRoutesService,
    protected projectActivityService: ProjectActivityService
  ) {
  }

  ngOnInit(): void {

  }

  ngAfterViewInit() {
    // const activityElem = jq(this.el.nativeElement)
    //
    // const elems = document.getElementsByClassName(this.activity.id + '')
    //
    //
    // // tslint:disable-next-line: deprecation
    // activityElem.hover(() => {
    //
    //   if (!this.logisticRoutesService.suggestionDndActive) {
    //     for (let i = 0; i < elems.length; i++) {
    //       jq(elems[i]).addClass('hovered-suggestion')
    //     }
    //   }
    // }, () => {
    //   for (let i = 0; i < elems.length; i++) {
    //     jq(elems[i]).removeClass('hovered-suggestion')
    //   }
    // })
  }

  chooseOriginalDate() {
    if (this.activity.isDateLock) {
      return;
    }
    this.activity.isDateLock = true;
    this.reSort()
  }

  chooseSuggestedDate() {
    if (!this.activity.isDateLock) {
      return;
    }
    this.activity.isDateLock = false;
    this.reSort()
  }

  reSort() {
    this.logisticRoutesService.serviceLogisticSuggestion.stale = true;

    this.projectActivityService.saveProjectActivity({
      id: this.activity.id,
      isDateLock: this.activity.isDateLock
    }).subscribe(() => {

    })

    this.logisticRoutesService.logisticSuggestionChangesSubj.next()
  }

  openProjectWindow() {
    this.dialog.open(ProjectWindowComponent, {
      data: {
        projectNumber: this.activity.project.id,
        serviceOrderIdToScroll: this.activity.serviceOrderId
      },
      panelClass: 'project-window-dialog'
    });
  }
}
